
document.addEventListener('DOMContentLoaded', function () {
    devtricker_attachFocusInEmailLoginInputOnLoad();
    devtricker_attachEmailLoginSubmitHandlerOnLoad();
});

async function devtricker_attachEmailLoginSubmitHandlerOnLoad() {

    const form = devtricker_dom_get_emailLoginForm();

    if (form) {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            // devtricker_process_emailLogin();
            devtricker_process_emailLoginPow();
        });
    }
}

async function devtricker_attachFocusInEmailLoginInputOnLoad() {


    const passwordInput = document.querySelector('#loginModal div[type="password"]');
    const usernameInput = document.querySelector('#loginModal div[type="text"]');

    if (passwordInput && usernameInput) {
        if (passwordInput) {
            passwordInput.removeAttribute("disabled");
            devtricker_transformDivToInput(passwordInput);
            devtricker_transformDivToInput(usernameInput);
        }

        // devtricker_dom_focus_focusInEmailLoginInput();
    }
}